import { getVehicleDocCounts, getVehicleDocDetialList, getVehicleDocSummaryList } from '_services';
import { exportVehicleDocumentsummaryReport, getDocumentVehicleCounts, getVehicleDocTypeListData, VehicleDocumentFetch } from '_services/accountsServices/vehicleDocTypeServices';
import { CommonDateRange, CustomPagination, CustomSelect } from 'components';
import Tab from 'components/common/Tab'
import { constant } from 'constants/constant';
import { utils } from 'helper';
import { API, AppConfig } from 'lib';
import { AddEditVehicleDocumentsModal } from 'modals';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
// import { newDate } from 'react-datepicker/dist/date_utils';
import { FaRegClock } from 'react-icons/fa6';
import { GrDocumentText } from 'react-icons/gr';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { IoWarningOutline } from 'react-icons/io5';
import { LuCircleCheckBig, LuRefreshCw } from 'react-icons/lu';
import { MdOutlineCancel } from 'react-icons/md';
import { PiWarningCircle } from 'react-icons/pi';
import { StorageServices } from 'utils';
import StorageService from 'utils/StorageServices';
import "./vehicleDocument.css"

const staticSummary = [
    "Insurance",
    "Registration Certificate (RC)",
    "Fitness",
    "Pollution PUC",
    "State Permit",
    "National Permit"
]

const staticObject = {
    1: 'Expired',
    2: 'Near expired',
    3: 'Added',
    4: 'Not Added'
}

const isCountArray = [
    { key: 1, label: "Own Vehicle" },
    { key: 2, label: "Market Vehicle" },
    { key: 3, label: "Leased Vehicle" },
]

const isFilterArray = [
    { key: 3, label: "Added", counts: 0, icon: <LuCircleCheckBig className='__surAdd' /> },
    { key: 4, label: "Not Added", counts: 0, icon: <FaRegClock className='__surNotAd' /> },
    { key: 2, label: "Near expired", counts: 0, icon: <PiWarningCircle className='__surNearEx' /> },
    { key: 1, label: "Expired", counts: 0, icon: <MdOutlineCancel className='__surExd' /> },
]

const VehicleDocument = ({ redirectFilterDetails, vehicleDocApiRef }) => {

    const [activeTabBtn, setActiveTabBtn] = useState(1);
    const loadingBarRef = useRef(null);
    const [docDetailList, setDocDetailList] = useState([]);
    const [documentTypeList, setDocumentTypeList] = useState([])
    const [ownershipCount, setOwnershipCount] = useState({});
    const [activeOwnershipNw, setActiveOwnershipNw] = useState(1);
    const [summaryList, setSummaryList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(null);

    const [otherDocumentShow, setOtherDocumentShow] = useState(false);
    const [documentCountsData, setDocumentCountsData] = useState(false);
    const [docCountArray, setDocCountArray] = useState(isCountArray);
    const [filterDocCountArray, setFilterDocCountArray] = useState(isFilterArray)

    let isToken = localStorage.getItem("token");

    const [selectedRange, setSelectedRange] = useState({
        startDate: '',
        endDate: '',
    });

    const itemsPerPage = 10;
    const [totalItems, setTotalItems] = useState(0);

    const [filter, setFilter] = useState({
        limit: 10,
        offset: 1,
        search: '',
        vehicle_ownership: 1,
        doc_status: "",
        doc_type_id: {},

        company_id: StorageServices?.getCompanyId(),
        vehicle_no: "",
        end_date: "",
        start_date: "",
    });

    useEffect(() => {
        if (redirectFilterDetails?.doc_type_id && documentTypeList?.length > 0) {
            setFilter((s) => ({
                ...s,
                vehicle_ownership: +redirectFilterDetails?.activeOwnershipNw || 1,
                doc_status: redirectFilterDetails?.activeStatus ? redirectFilterDetails?.activeStatus : '',
                doc_type_id: redirectFilterDetails?.doc_type_id ? documentTypeList?.find((f) => f?.value == redirectFilterDetails?.doc_type_id) : {},
            }))
            setActiveTabBtn(redirectFilterDetails?.activeTab);
            setActiveOwnershipNw(+redirectFilterDetails?.activeOwnershipNw);
        }
    }, [redirectFilterDetails, documentTypeList])

    // useEffect(() => {
    //     if (!documentTypeList.length) return;

    //     if (redirectFilterDetails?.activeOwnershipNw) {
    //         setFilter((prev) => ({
    //             ...prev,
    //             vehicle_ownership: redirectFilterDetails?.activeOwnershipNw || 1,
    //             doc_status: redirectFilterDetails?.activeStatus || "",

    //             doc_type_id: redirectFilterDetails?.doc_type_id
    //                 ? documentTypeList.find((d) => d.value === redirectFilterDetails.doc_type_id)
    //                 : { label: "", value: "" }
    //         }));

    //         setActiveStatus(redirectFilterDetails?.activeStatus)
    //         setActiveOwnershipNw(redirectFilterDetails?.activeOwnershipNw)

    //         if (redirectFilterDetails?.activeTab) {
    //             setActiveTabBtn(redirectFilterDetails.activeTab);
    //         }
    //     }
    // }, [documentTypeList, redirectFilterDetails]);


    const fetchVehicleDocs = useCallback(async () => {
        setLoading(true)
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                vehicle_ownership: activeOwnershipNw
            }
            const response = await fetch(`${AppConfig.api_baseurl}${API.EXPORT_VEHICLE_DOCUMENT_SUMMARY}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}));
                if (errorBody?.responseMessage) {
                    toast.error(errorBody?.responseMessage);
                }
                throw new Error(`Server Error (${errorBody?.responseMessage})`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vehicle_Document.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }

    }, [activeOwnershipNw]);


    useEffect(() => {
        if (vehicleDocApiRef) {
            vehicleDocApiRef.current = fetchVehicleDocs;
        }
    }, [activeOwnershipNw]);

    const tabBtnProps = {
        tabList: constant.summryDocsTabs,
        callBackTab: (e) => { setActiveTabBtn(e); setFilter((s) => ({ ...s, offset: 1, search: "", doc_type_id: {}, doc_status: "" })) },
        activeTab: activeTabBtn,
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const getDocumentType = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
            }
            const res = await getVehicleDocTypeListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.docTypes?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                        id: el?.id
                    }
                })
                setDocumentTypeList(data);
            }
        } catch (error) { }
    }

    const getDocumentCounts = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getDocumentVehicleCounts(object);
            if (res?.responseCode == 200) {
                setDocumentCountsData(res?.data);
                let filterArr = [
                    { key: 3, label: "Added", counts: res?.data?.docStatusCount[filter.vehicle_ownership]['Added'], icon: <LuCircleCheckBig className='__surAdd' /> },
                    { key: 4, label: "Not Added", counts: res?.data?.docStatusCount[filter.vehicle_ownership]['Not_Added'], icon: <FaRegClock className='__surNotAd' /> },
                    { key: 2, label: "Near expired", counts: res?.data?.docStatusCount[filter.vehicle_ownership]['Near_expiry'], icon: <PiWarningCircle className='__surNearEx' /> },
                    { key: 1, label: "Expired", counts: res?.data?.docStatusCount[filter.vehicle_ownership]['Expired'], icon: <MdOutlineCancel className='__surExd' /> },
                ];
                let updatedArray = [
                    { key: 1, label: "Own Vehicle", counts: res?.data?.ownershipCount[1] },
                    { key: 2, label: "Market Vehicle", counts: res?.data?.ownershipCount[2] },
                    { key: 3, label: "Leased Vehicle", counts: res?.data?.ownershipCount[3] },
                ]
                setDocCountArray(updatedArray);
                setFilterDocCountArray(filterArr);
            }
        } catch (error) { }
    }

    const handleDocumentFetch = async (vehicle_no) => {
        setFetchLoading(vehicle_no)

        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                vehicle_no: vehicle_no
            }

            const res = await VehicleDocumentFetch(object);

            if (res?.responseCode == 200) {

                if (res.responseMessage === "Vehicle documents added successfully.") {
                    toast.success(res.responseMessage);

                    await vehicleDocSummaryList();

                } else {
                    toast.error(res.responseMessage);
                }

            }

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong!");
        } finally {
            setFetchLoading(null);
        }
    }

    const vehicleDocSummaryList = async () => {
        try {
            loadingBarRef.current?.continuousStart();
            let object = {
                ...filter,
                vehicle_no: filter?.search,
                company_id: StorageService.getCompanyId(),
            };
            delete object.search;

            const res = await getVehicleDocSummaryList(object);

            if (res?.responseCode == 200) {
                setSummaryList(res.data.data);
                setOwnershipCount(res.data.ownershipCount);
                setTotalItems(res?.data?.total);
            }

        } finally {
            loadingBarRef.current?.complete();
        }
    };

    const vehicleDocDetailList = async () => {
        try {
            loadingBarRef.current?.continuousStart();
            let object = {
                ...filter,
                doc_type_id: filter?.doc_type_id?.value,
                vehicle_no: filter?.search,
                start_date: selectedRange?.startDate
                    ? moment(selectedRange.startDate).format("YYYY-MM-DD")
                    : null,

                end_date: selectedRange?.endDate
                    ? moment(selectedRange.endDate).format("YYYY-MM-DD")
                    : null,
                company_id: StorageService.getCompanyId(),
                doc_status: filter?.doc_status
            };
            delete object.search;

            const res = await getVehicleDocDetialList(object);

            if (res?.responseCode == 200) {
                const list = res?.data?.data;
                setDocDetailList(list);
                setOwnershipCount(res?.data?.ownershipCount);
                setTotalItems(res?.data?.total);
            }
        } finally {
            loadingBarRef.current?.complete();
        }
    };

    const getDocumentStatus = (documents, docType) => {
        const doc = documents?.find(d => d.doc_type_name?.toLowerCase() === docType.toLowerCase());

        if (!doc) {
            return { status: 'not_added', expiryDate: null };
        }

        switch (doc.status) {
            case 1: return { status: 'expired', expiryDate: doc.expiry_date };
            case 2: return { status: 'near_expiry', expiryDate: doc.expiry_date };
            case 3: return { status: 'valid', expiryDate: doc.expiry_date };
            case 4: return { status: 'not_added', expiryDate: null };
            default: return { status: 'not_added', expiryDate: null };
        }
    };

    const getStatusUI = (status, expiry_date) => {
        switch (status) {
            case 1:
                return (
                    <div className='__vlExpireWrn_bx'>
                        <IoWarningOutline />
                        <span>Expired</span>
                    </div>
                );
            case 2:
                return (
                    <div className='__vlExpireSoon_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Expires soon</span>
                    </div>
                );
            case 3:
                return (
                    <div className='__vlVailid_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Valid</span>
                    </div>
                );
            case 4:
                return (
                    <div className='__vlNotAdd_bx'>
                        <IoWarningOutline />
                        <span>Not Added</span>
                    </div>
                );
            default:
                return "-";
        }
    };

    useEffect(() => {
        getDocumentType();
    }, [])

    useEffect(() => {
        getDocumentCounts();
    }, [filter?.vehicle_ownership]) // filter

    useEffect(() => {
        if (activeTabBtn === 1) {
            vehicleDocSummaryList();
        }
        if (activeTabBtn === 2) {
            vehicleDocDetailList();
        }
    }, [filter, activeTabBtn]);

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setFilter((prev) => ({
            ...prev,
            start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
            offset: 1,
        }));
    };

    const clearFunction = () => {
        setSelectedRange({
            startDate: '',
            endDate: '',
        })
        setFilter((s) => ({
            ...s,
            limit: 10,
            offset: 1,
            doc_type_id: {},
            start_date: "",
            end_date: "",
            search: "",
            // vehicle_ownership: 1,
            vehicle_no: "",
            // doc_status: "",
            company_id: StorageService.getCompanyId(),
        }));
    }

    return (
        <>
            <div className='__trcVl_main'>
                <div className='__trcVl_topFilts'>
                    {docCountArray.map(item => (
                        <div
                            key={item.key}
                            className={`__trvl_flt ${activeOwnershipNw == item.key ? "__trvlActive" : ""}`}
                            onClick={() => {
                                setActiveOwnershipNw(item.key);
                                setFilter(s => ({ ...s, vehicle_ownership: +item.key, offset: 1, search: "" }));
                            }}
                        >
                            <p>{item.label}</p>
                            <h2>{item?.counts ? item?.counts : 0}</h2>
                        </div>
                    ))}
                </div>

                <div className='__surTab_viewBx'>
                    <Tab {...tabBtnProps} />
                </div>
                {activeTabBtn === 1 &&
                    <>
                        <div className='__surSearch_vs'>
                            <div className='__surSeaInner_fils'>
                                <div className="_inpW_search _lrl_inpSrch">
                                    <svg className="srcIcon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path opacity="0.2" d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z" fill="black"></path>
                                    </svg>
                                    <input
                                        type="search"
                                        placeholder="Search By Vehicle Number"
                                        className="simpleFilter_input"
                                        name="search"
                                        value={filter.search}
                                        onChange={(e) =>
                                            setFilter(prev => ({ ...prev, search: e.target.value, offset: 1 }))
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='__surCommonTableWrapper'>
                            <div className="__surCommonTable __surMFirst">

                                <div className="table-row table-header _trCts">
                                    <div className="table-cell">Vehicle Number</div>
                                    <div className="table-cell">Insurance</div>
                                    <div className="table-cell">RC</div>
                                    <div className="table-cell">Fitness</div>
                                    <div className="table-cell">Pollution</div>
                                    <div className="table-cell">State Permit</div>
                                    <div className="table-cell">National Permit</div>
                                </div>

                                {
                                    summaryList?.length > 0 ?
                                        summaryList?.map((item, index) => {
                                            return (
                                                <div key={index} className="table-row">
                                                    <div className="table-cell __surVhlD _acenter">
                                                        <div>
                                                            <h4>{item.vehicle_no}</h4>
                                                            <p>{item.vehicle_type || 'Vehicle'}</p>
                                                        </div>

                                                        <button
                                                            onClick={() => handleDocumentFetch(item.vehicle_no)}
                                                            className="refreshBtn"
                                                        >
                                                            <LuRefreshCw className={fetchLoading === item.vehicle_no ? "spin-animation" : ""} />
                                                        </button>
                                                    </div>
                                                    {
                                                        staticSummary.map((type, i) => {
                                                            const doc = item.documents?.find(d => d.doc_type_name === type);
                                                            return (
                                                                <div key={i} className="table-cell">
                                                                    {(doc?.id && doc?.expiry_date) ?
                                                                        <div
                                                                            className='__supSm_bx _avPointer'
                                                                            onClick={(e) =>
                                                                                setOtherDocumentShow({
                                                                                    ...doc,
                                                                                    doc_type_id: { name: doc?.doc_type_name, id: doc?.doc_type_id },
                                                                                    lorry_type: item.lorry_type,
                                                                                    vehicle_no: item.vehicle_no,
                                                                                    vehicle_ownership: item.vehicle_ownership,
                                                                                    vehicle_type: item.vehicle_type,
                                                                                    editDocument: true,
                                                                                    viewDocument: true
                                                                                })}
                                                                        >
                                                                            <p style={{ color: (doc?.status === 1 ? '#E7000B' : (doc?.status === 2 ? '#CA3500' : (doc?.status === 3 ? "#000" : "#FFF7ED"))) }}>{staticObject[doc?.status]}</p>
                                                                            <span className='_spanCls_ft'> {doc?.expiry_date ? utils.formatDateMonth(doc?.expiry_date) : '-'}</span>
                                                                            <p className='__supSm_renew _avPointer'
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation(e);
                                                                                    setOtherDocumentShow({
                                                                                        ...doc,
                                                                                        doc_type_id: { name: doc?.doc_type_name, _id: doc?.doc_type_id },
                                                                                        _id: doc?.id,
                                                                                        lorry_type: item.lorry_type,
                                                                                        vehicle_no: item.vehicle_no,
                                                                                        vehicle_ownership: item.vehicle_ownership,
                                                                                        vehicle_type: item.vehicle_type,
                                                                                        editDocument: true,
                                                                                        viewDocument: false,
                                                                                        onlyOneFieldDisable: true,
                                                                                    })
                                                                                }}
                                                                            >Renew</p>
                                                                        </div>
                                                                        :
                                                                        <div className='__supSm_bx'>
                                                                            <button
                                                                                className='__supSm_addD'
                                                                                onClick={() => setOtherDocumentShow({
                                                                                    ...doc,
                                                                                    doc_type_id: { label: doc?.doc_type_name, value: doc?.doc_type_id },
                                                                                    lorry_type: item.lorry_type,
                                                                                    vehicle_no: item.vehicle_no,
                                                                                    vehicle_ownership: item.vehicle_ownership,
                                                                                    vehicle_type: item.vehicle_type,
                                                                                    addDocument: true,
                                                                                    isCategoryDisable: true,
                                                                                    editDocument: false,
                                                                                    viewDocument: false
                                                                                })}
                                                                            >
                                                                                + Add Details
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            );
                                        }) :
                                        <div className="table-row">
                                            <div className="table-cell __surVhlD">
                                                No Records
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>

                        {/* <div className='paginationFt_avt '>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div> */}

                        {/* <div
                        className={`offcanvas offcanvas-end common_offCanvas ${otherDocumentShow ? 'show' : ''}`}
                        tabIndex={-1}
                        style={{ visibility: otherDocumentShow ? 'visible' : 'hidden' }}
                    >
                        {otherDocumentShow &&
                            <AddEditVehicleDocumentsModal
                                isOpen={otherDocumentShow}
                                onClose={(e) => setOtherDocumentShow(false)}
                                callListApi={() => vehicleDocSummaryList()}
                            />
                        }
                    </div>
                    <div className={otherDocumentShow ? 'offBack_drop' : ''}></div> */}
                    </>
                }

                {activeTabBtn === 2 &&
                    <>
                        <div className='__surSearch_vs'>
                            <div className='__surSeaInner_fils'>
                                <div className="_inpW_search _lrl_inpSrch">
                                    <svg className="srcIcon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path opacity="0.2" d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z" fill="black"></path></svg>
                                    <input
                                        type="search"
                                        placeholder="Search By Vehicle Number"
                                        className="simpleFilter_input"
                                        name="search"
                                        value={filter.search}
                                        onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value, offset: 1 }))}
                                    />
                                </div>

                                <div className='__surFiltersBx'>
                                    <div className='__surFl_tabs'>
                                        {
                                            filterDocCountArray?.map((item, index) => {
                                                return (
                                                    <React.Fragment key={item?.key + item?.label + index}>
                                                        <button
                                                            className={`__surTbX ${filter.doc_status === item?.key ? `__surTbX_active` : ``}`}
                                                            onClick={() => setFilter((prev) => ({ ...prev, offset: 1, doc_status: item?.key }))}
                                                        >
                                                            {item?.icon}
                                                            {`${item?.label} ${item?.counts}`}
                                                        </button>
                                                    </React.Fragment>
                                                )
                                            })
                                        }

                                    </div>

                                    <CustomSelect
                                        options={documentTypeList}
                                        placeholder='All Document Type'
                                        name="doc_type_id"
                                        label="Document Type"
                                        value={filter?.doc_type_id?.id ? documentTypeList?.find((f) => f?.id === filter?.doc_type_id?.id) : { label: "", value: "" }}
                                        onSelect={(data) => setFilter((s) => ({ ...s, doc_type_id: data }))}
                                    />

                                    <CommonDateRange
                                        initialStartDate={selectedRange.startDate || ""}
                                        initialEndDate={selectedRange.endDate || ""}
                                        onApply={handleApply}
                                        datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
                                    // actionWidthLeft={true}
                                    />

                                    <button className='anime-btn __surReset' onClick={(e) => clearFunction(e)}>
                                        Reset
                                    </button>
                                </div>

                            </div>

                        </div>

                        <div className='__surCommonTable __surMSecond'>
                            <table>
                                <thead>
                                    <tr>
                                        <th><span>Vehicle Number</span></th>
                                        <th><span>Document info</span></th>
                                        <th><span>Issue Date</span></th>
                                        <th><span>Expiry Date</span></th>
                                        <th><span>Status</span></th>
                                        <th><span>Last Updated</span></th>
                                        <th><span>Actions</span></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {docDetailList
                                        .map((row, index) => (
                                            <tr key={index}>

                                                <td>
                                                    <div className='__vhlDoc_nums'>
                                                        <div className='__vlDocCountBx'>
                                                            <GrDocumentText />
                                                        </div>
                                                        <div className='__vlDocNums'>
                                                            <p>{row.vehicle_no}</p>
                                                            <span>
                                                                {row.vehicle_ownership === 1
                                                                    ? "Own"
                                                                    : row.vehicle_ownership === 2
                                                                        ? "Market"
                                                                        : "Leased"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className='__vlDocInfo'>
                                                        <p>{row.doc_type_name}</p>
                                                        <span>{row.document_no || "-"}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <p className='__vlIssue_date'>
                                                        {row.issue_date ? utils.formatDateMonth(row.issue_date) : "-"}
                                                    </p>
                                                </td>

                                                <td>
                                                    <p
                                                        className={
                                                            row.status === 1
                                                                ? "__vlExpire_date"
                                                                : row.status === 2
                                                                    ? "__vlExpireWrn_date"
                                                                    : row.expiry_date
                                                                        ? "__vlExpire_date_na"
                                                                        : "__vlExpire_date"
                                                        }
                                                    >
                                                        {row.expiry_date ? utils.formatDateMonth(row.expiry_date) : "-"}
                                                    </p>
                                                </td>

                                                <td>
                                                    {getStatusUI(row.status, row.expiry_date)}
                                                </td>

                                                <td>
                                                    <p className='__vlLast_date'>
                                                        {row.last_updated
                                                            ? utils.formatUiDateTime(row.last_updated)
                                                            : "Never"}
                                                    </p>
                                                </td>

                                                <td>
                                                    {row.status === 4 ? (
                                                        <button
                                                            className='anime-btn __vlAddBtn'
                                                            onClick={() => setOtherDocumentShow({
                                                                ...row,
                                                                doc_type_id: { label: row?.doc_type_name, value: row?.doc_type_id },
                                                                lorry_type: row.lorry_type,
                                                                vehicle_no: row.vehicle_no,
                                                                vehicle_ownership: row.vehicle_ownership,
                                                                vehicle_type: row.vehicle_type,
                                                                addDocument: true,
                                                                isCategoryDisable: true,
                                                                editDocument: false,
                                                                viewDocument: false
                                                            })}
                                                        >
                                                            Add
                                                        </button>
                                                    ) : row.status === 3 ? (
                                                        <button
                                                            className='anime-btn __vlViewBtn'
                                                            onClick={(e) =>
                                                                setOtherDocumentShow({
                                                                    ...row,
                                                                    doc_type_id: { name: row?.doc_type_name, id: row?.doc_type_id },
                                                                    lorry_type: row.lorry_type,
                                                                    vehicle_no: row.vehicle_no,
                                                                    vehicle_ownership: row.vehicle_ownership,
                                                                    vehicle_type: row.vehicle_type,
                                                                    editDocument: true,
                                                                    viewDocument: true
                                                                })}
                                                        >View</button>
                                                    ) : (
                                                        <button
                                                            className='anime-btn __vlUpdateBtn'
                                                            onClick={(e) => {
                                                                setOtherDocumentShow({
                                                                    ...row,
                                                                    doc_type_id: { name: row?.doc_type_name, _id: row?.doc_type_id },
                                                                    _id: row?.id,
                                                                    lorry_type: row.lorry_type,
                                                                    vehicle_no: row.vehicle_no,
                                                                    vehicle_ownership: row.vehicle_ownership,
                                                                    vehicle_type: row.vehicle_type,
                                                                    editDocument: true,
                                                                    viewDocument: false
                                                                })
                                                            }}
                                                        >Update</button>
                                                    )}
                                                </td>

                                            </tr>
                                        ))}

                                    {docDetailList.length === 0 && (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center', padding: '15px' }}>
                                                <p style={{ fontSize: '14px', margin: '0px' }}>No vehicles found</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </>
                }
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${otherDocumentShow ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: otherDocumentShow ? 'visible' : 'hidden' }}
            >
                {otherDocumentShow &&
                    <AddEditVehicleDocumentsModal
                        isOpen={otherDocumentShow}
                        onClose={(e) => setOtherDocumentShow(false)}
                        callListApi={() => vehicleDocDetailList()}
                    />
                }
            </div>
            <div className={otherDocumentShow ? 'offBack_drop' : ''}></div>

            <div className='paginationFt_avt '>
                <CustomPagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    currentPage={filter.offset}
                    onPageChange={handlePageChange}
                />
            </div>
        </>
    )
}

export default VehicleDocument